<template>
  <div class="container-fluid netpa-home" :class="{ 'is-editing': dashboardEditMode }">
    <div class="netpa-home__layout">
      <div class="netpa-home__toolbar">
        <button
          type="button"
          class="netpa-home__toolbar-btn"
          :class="{ 'is-active': dashboardEditMode }"
          @click="toggleDashboardEdit"
        >
          <i
            :class="dashboardEditMode ? 'fas fa-check' : 'fas fa-th-large'"
            aria-hidden="true"
          ></i>
          {{ dashboardEditMode ? "انجام شد" : "داشبورد سفارشی" }}
        </button>
        <button
          type="button"
          class="netpa-home__toolbar-btn netpa-home__toolbar-btn--ghost"
          @click="resetHomeLayout"
        >
          <i class="fas fa-undo" aria-hidden="true"></i>
          بازگشت به حالت پیش فرض
        </button>
        <span v-if="dashboardEditMode" class="netpa-home__toolbar-hint">
          کارت را بکشید و در جای خالی خط‌چین رها کنید، بعد «انجام شد» را بزنید.
        </span>
      </div>

      <div
        v-if="showHomeBoard"
        class="netpa-home__dashboard netpa-home__columns"
        :class="{
          'netpa-home__dashboard--with-side': dashboardHasTwoColumns,
          'netpa-home__dashboard--has-full': dashboardHasFullRow,
          'netpa-home__dashboard--has-charts': dashboardHasChartsRow,
        }"
      >
        <div
          v-for="col in boardColumns"
          :key="col.name"
          class="netpa-home__stack"
          :class="'netpa-home__stack--' + col.kind"
        >
          <div
            v-for="(id, index) in col.ids"
            :key="col.name + '-' + id"
            class="netpa-home__cell"
          >
            <div
              v-if="dashboardEditMode"
              class="netpa-home__drop-slot"
              :data-list="col.name"
              :data-index="index"
              @dragover="onSlotDragOver"
              @drop="onSlotDrop"
            >
              رها کنید
            </div>
            <div
              v-if="id === 'zemanat'"
              :key="id"
              class="netpa-home__panel netpa-home__widget"
              data-widget="zemanat"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
          <net-pa-card
            :Classes="'bg-orange'"
            :IsMinus="false"
            :IdElement="'Zemanat'"
            v-if="$store.state.renderComponent"
          >
            <template v-slot:header>
              <h6 class="text-dark">
                <i class="fas fa-exclamation-triangle ml-2"></i>درخواست ضمانت
              </h6>
            </template>
            <template v-slot:content>
              <div
                class="row boder-bottom pr-2 pl-3"
                v-for="nv in ListReqNeedVam"
                :key="nv.id"
              >
                <div class="col-12 my-2 mx-1 w-100 Netpa-Shadow-2 mt-1 py-3">
                  <div class="row">
                    <div class="col-md-3 col-12 text-center">
                      <div class="">
                        <small class="text-dark font-weight-bold mt-2">
                          {{ nv.subjectTabloElanat }}
                        </small>
                      </div>
                      <div class="mt-1">
                        <small
                          class="text-danger font-weight-bold mt-2"
                          style="font-size: 14px"
                        >
                          {{ nv.desNoe }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-3 col-12 text-center">
                      <span class="text-secondary"> مشخصات</span>
                      <small class="font-weight-bold mt-2">
                        {{ nv.nameFamily }}
                      </small>

                      <div class="mt-1">
                        <span class="text-secondary"> کد ملی</span>
                        <small class="font-weight-bold mt-2">
                          {{ nv.codeMeli }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-2 col-12 text-center">
                      <span class="text-secondary">
                        مبلغ
                        {{
                          $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد"
                        }}
                      </span>
                      <div>
                        <small
                          class="text-danger font-weight-bold mt-2"
                          style="font-size: 16px"
                        >
                          {{ $Comma3ragham(nv.mablagh) }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-2 col-12 text-center">
                      <span class="text-secondary"> تاریخ درخواست </span>
                      <div class="mt-1">
                        <small class="text-dark font-weight-bold mt-2">
                          {{ nv.zamanInsert }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-2 col-12 text-center">
                      <div
                        @click="RqNeedVam(nv.id, 1, nv)"
                        class="badge badge-success p-1 px-3 py-1 font-weight-normal Pointer w-75"
                        style="border-radius: 4px"
                      >
                        <i class="fa fa-check ml-2"></i> تایید ضمانت
                      </div>
                      <div
                        @click="RqNeedVam(nv.id, 2, nv)"
                        class="badge badge-danger p-1 px-3 py-1 font-weight-normal Pointer mt-1 w-75"
                      >
                        <i class="fa fa-times ml-2"></i> رد ضمانت
                      </div>
                      <input
                        type="file"
                        @change="changefile"
                        class="d-none required"
                        id="Uploader"
                        accept=".gif,.jpg,.jpeg,.png,.pdf,.zip,.rar"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </net-pa-card>
        </div>
            <div
              v-else-if="id === 'moavaghaat'"
              :key="id"
              class="netpa-home__panel netpa-home__widget"
              data-widget="moavaghaat"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
          <net-pa-card
            :Classes="'bg-danger'"
            :IsMinus="true"
            :IdElement="'Moavaghaat'"
            v-if="$store.state.renderComponent"
          >
            <template v-slot:header>
              <h6>
                <i class="fas fa-exclamation-triangle ml-2"></i>اقساط معوقه
              </h6>
            </template>
            <template v-slot:content>
              <div
                v-for="(item, index) in Moavaghaat"
                :key="index"
                class="netpa-overdue"
              >
                <div class="netpa-overdue__cell">
                  <span class="netpa-overdue__label">{{ item.desNoe }}</span>
                  <small class="netpa-overdue__meta" dir="rtl">{{ item.vCode }}</small>
                </div>
                <div class="netpa-overdue__cell">
                  <span class="netpa-overdue__label">تعداد اقساط معوقه</span>
                  <strong class="netpa-overdue__value">{{ item.countMoavaghe }}</strong>
                </div>
                <div class="netpa-overdue__cell">
                  <span class="netpa-overdue__label">مجموع معوقه</span>
                  <strong class="netpa-overdue__value">
                    {{ item.sumMoavaghe }}
                    <small dir="rtl">{{ $GetVahedPool() }}</small>
                  </strong>
                </div>
                <div class="netpa-overdue__cell">
                  <span class="netpa-overdue__label">تاریخ</span>
                  <small class="netpa-overdue__meta" dir="rtl">{{ item.zamanInsert }}</small>
                </div>
                <div
                  class="netpa-overdue__cell netpa-overdue__cell--action"
                  v-if="item.tblSarfaslTypeId == 1"
                >
                  <router-link
                    class="netpa-overdue__link"
                    :to="{
                      name: 'LoanCardex',
                      params: { TaahodatId: item.id },
                    }"
                  >
                    <i class="fas fa-plus" aria-hidden="true"></i>
                    کاردکس
                  </router-link>
                </div>
              </div>
            </template>
          </net-pa-card>
        </div>

            <div
              v-else-if="id === 'fastpay'"
              :key="id"
              class="netpa-home__panel netpa-home__widget"
              data-widget="fastpay"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
            <net-pa-card>
              <template v-slot:header>
                <h6>
                  <i class="fas fa-credit-card ml-2"></i>پرداخت سریع
                </h6>
              </template>
              <template v-slot:content>
                <div class="netpa-fastpay">
                  <div class="netpa-fastpay__hero">
                    <div class="netpa-fastpay__hero-top">
                      <span>کل مبلغ سررسید شده</span>
                      <span class="netpa-fastpay__chip">
                        <i class="fas fa-bolt" aria-hidden="true"></i>
                        {{ FastpaymentData.length }} مورد
                      </span>
                    </div>
                    <span class="netpa-fastpay__hero-label"
                      >مبلغ قابل پرداخت</span
                    >
                    <div class="netpa-fastpay__hero-amount">
                      {{ $Comma3ragham(TotalFastPay.SumMabFastPay + "") }}
                      <small>{{ $GetVahedPool() }}</small>
                    </div>
                    <p class="netpa-fastpay__hero-words">
                      {{ $Mab2persianRial(TotalFastPay.SumMabFastPay + "") }}
                    </p>
                    <div class="netpa-fastpay__hero-meta">
                      <span>
                        بابت
                        <b>{{ TotalFastPay.VamCoutFastPay }}</b>
                        {{
                          $GetIsAnbohSaz() == 'false' ? "وام" : "پروژه"
                        }}
                      </span>
                      <span>
                        جریمه
                        <b>{{
                          $Comma3ragham(TotalFastPay.SumJarmieFastPay)
                        }}</b>
                      </span>
                    </div>
                    <button
                      type="button"
                      class="netpa-fastpay__btn"
                      :disabled="TotalFastPay.SumMabFastPay == 0"
                      @click="Pay"
                    >
                      پرداخت سریع
                    </button>
                  </div>

                  <div class="netpa-fastpay__list-wrap" dir="rtl">
                    <div class="netpa-fastpay__list-label">
                      انتخاب اقساط برای پرداخت
                    </div>
                    <div class="netpa-fastpay__list">
                      <article
                        v-for="(item, index) in FastpaymentData"
                        :key="index"
                        class="netpa-fastpay__item"
                        :class="{
                          'is-active': FastpaymentData[index].Active,
                        }"
                      >
                        <label
                          class="netpa-fastpay__check"
                          :for="FastpaymentData[index].vCode + 'active'"
                        >
                          <input
                            type="checkbox"
                            class="InputText"
                            v-model="FastpaymentData[index].Active"
                            :id="FastpaymentData[index].vCode + 'active'"
                          />
                          <span>انتخاب</span>
                        </label>
                        <div class="netpa-fastpay__fields">
                          <div class="netpa-fastpay__field">
                            <span>{{
                              $GetIsAnbohSaz() == 'false'
                                ? "تسهیلات"
                                : "پروژه"
                            }}</span>
                            <strong>{{ item.desNoe }}</strong>
                          </div>
                          <div class="netpa-fastpay__field">
                            <span>{{
                              $GetIsAnbohSaz() == 'false'
                                ? "شماره قرارداد"
                                : "شماره تسهیلات"
                            }}</span>
                            <strong dir="rtl">{{ item.vCode }}</strong>
                          </div>
                          <div class="netpa-fastpay__field">
                            <span>تاریخ قسط</span>
                            <strong dir="rtl">{{
                              item.minTarGhestBedehkar
                            }}</strong>
                          </div>
                          <div class="netpa-fastpay__field">
                            <span>قابل پرداخت</span>
                            <strong>{{
                              $Comma3ragham(item.mablghPardakht + "")
                            }}</strong>
                          </div>
                          <div class="netpa-fastpay__field">
                            <span>جریمه</span>
                            <strong class="is-penalty">{{
                              item.wwwjarime == null
                                ? 0
                                : $Comma3ragham(item.wwwjarime + "")
                            }}</strong>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>

            <div
              v-else-if="id === 'loan'"
              :key="id"
              class="netpa-home__panel netpa-home__widget"
              data-widget="loan"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
            <net-pa-card v-if="$store.state.renderComponent">
              <template v-slot:header>
                <h6>
                  <i class="fas fa-chart-line ml-2"></i
                  >{{
                    $GetIsAnbohSaz() == "false"
                      ? "وضعیت تسهیلات"
                      : "وضعیت قرارداد"
                  }}
                </h6>
              </template>
              <template v-slot:content>
                <div v-if="ChartLoaded == 'loading'" class="row px-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div v-else class="container-fluid" dir="ltr">
                  <apexchart
                    v-if="$store.state.renderComponent"
                    type="bar"
                    height="280"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </template>
            </net-pa-card>
          </div>

            <div
              v-else-if="id === 'tabloo'"
              :key="id"
              class="netpa-home__panel netpa-home__widget"
              data-widget="tabloo"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
          <net-pa-card>
            <template v-slot:header>
              <div
                class="d-flex justify-content-between align-items-center w-100"
              >
                <h6 class="mb-0">
                  <i class="fas fa-bell ml-2 text-warning"></i>تابلو اعلانات
                </h6>
                <button
                  type="button"
                  class="btn btn-sm netpa-notices__filter-btn"
                  @click="toggleReadFilter"
                >
                  <i class="fas fa-check-double ml-1"></i>خوانده شده
                </button>
              </div>
            </template>
            <template v-slot:content>
              <div class="netpa-notices__body">
                <div v-if="Tabloo == 'loading'" class="netpa-notices__loading">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <template v-else>
                  <article
                    v-for="(item, index) in filteredTabloo"
                    :key="index"
                    class="netpa-notice"
                  >
                    <span class="netpa-notice__dot" aria-hidden="true"></span>
                    <div class="netpa-notice__copy">
                      <div class="netpa-notice__top">
                        <strong>{{ item.subjectTabloElanat }}</strong>
                        <time>{{ item.zamanInsert }}</time>
                      </div>
                      <p>{{ item.txtMatnTabloElanat }}</p>
                      <div class="netpa-notice__actions">
                        <button
                          v-if="item.txtMatnTabloElanat.length > 60"
                          type="button"
                          class="netpa-notice__btn"
                          @click="ShowFullNotif(item)"
                          data-toggle="modal"
                          data-target="#Modal-light"
                        >
                          مشاهده کامل
                        </button>
                        <button
                          v-if="!isItemRead(item)"
                          type="button"
                          class="netpa-notice__btn netpa-notice__btn--read"
                          @click="markAsReadWithConfirm(item)"
                        >
                          خواندم
                        </button>
                      </div>
                    </div>
                  </article>
                  <div
                    v-if="filteredTablooLength < 1"
                    class="netpa-notices__empty"
                  >
                    {{
                      showReadOnly
                        ? "اعلان خوانده شده‌ای یافت نشد"
                        : "اعلانی یافت نشد"
                    }}
                  </div>
                </template>
              </div>
            </template>
          </net-pa-card>
          </div>

            <div
              v-else-if="id === 'quick'"
              :key="id"
              class="netpa-home__panel netpa-home__widget"
              data-widget="quick"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
          <net-pa-card>
            <template v-slot:header>
              <h6>
                <i class="fas fa-bolt ml-2" aria-hidden="true"></i>دسترسی سریع
              </h6>
            </template>
            <template v-slot:content>
              <div class="netpa-quick__grid netpa-quick__grid--side">
                <router-link
                  v-for="(item, index) in visibleQuickAccessItems"
                  :key="index"
                  :to="item.linkTo"
                  class="netpa-quick__action"
                >
                  <span class="netpa-quick__icon" aria-hidden="true">
                    <i :class="item.iconClass"></i>
                  </span>
                  <span>{{ item.text }}</span>
                </router-link>
              </div>
            </template>
          </net-pa-card>
            </div>
            <div
              v-else-if="id === 'accounts'"
              :key="id"
              class="netpa-home__panel netpa-home__panel--chart netpa-home__widget"
              data-widget="accounts"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
              <net-pa-card>
                <template v-slot:header>
                  <h6>
                    <i class="fas fa-chart-pie ml-2" aria-hidden="true"></i>نمودار
                    حساب‌ها
                  </h6>
                </template>
                <template v-slot:content>
                  <AccountsChart></AccountsChart>
                </template>
              </net-pa-card>
            </div>
            <div
              v-else-if="id === 'fund'"
              :key="id"
              class="netpa-home__panel netpa-home__panel--chart netpa-home__widget"
              data-widget="fund"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
              <net-pa-card>
                <template v-slot:header>
                  <h6>
                    <i class="fas fa-chart-line ml-2" aria-hidden="true"></i>نمودار
                    ذخیره صندوق
                  </h6>
                </template>
                <template v-slot:content>
                  <FundReserveChart></FundReserveChart>
                </template>
              </net-pa-card>
            </div>
            <div
              v-else-if="id === 'profit'"
              :key="id"
              class="netpa-home__panel netpa-home__panel--chart netpa-home__widget"
              data-widget="profit"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
              <net-pa-card>
                <template v-slot:header>
                  <h6>
                    <i class="fas fa-chart-bar ml-2" aria-hidden="true"></i>وضعیت
                    تسویه سود
                  </h6>
                </template>
                <template v-slot:content>
                  <ProfitSettlementChart></ProfitSettlementChart>
                </template>
              </net-pa-card>
            </div>
            <div
              v-else-if="id === 'allocated'"
              :key="id"
              class="netpa-home__panel netpa-home__panel--chart netpa-home__widget"
              data-widget="allocated"
              :draggable="dashboardEditMode"
              @dragstart="onWidgetDragStart"
              @dragover="onWidgetDragOver"
              @drop="onWidgetDrop"
              @dragend="onWidgetDragEnd"
            >
              <net-pa-card>
                <template v-slot:header>
                  <h6>
                    <i class="fas fa-chart-bar ml-2" aria-hidden="true"></i>سود های
                    تخصیص یافته به اعضا
                  </h6>
                </template>
                <template v-slot:content>
                  <AllocatedProfitsChart></AllocatedProfitsChart>
                </template>
              </net-pa-card>
            </div>
          </div>
          <div
            v-if="dashboardEditMode"
            :key="'slot-end-' + col.name"
            class="netpa-home__drop-slot"
            :data-list="col.name"
            :data-index="col.ids.length"
            @dragover="onSlotDragOver"
            @drop="onSlotDrop"
          >
            رها کنید
          </div>
        </div>
      </div>

      <!-- پرداخت قبوض -->
      <div
        class="netpa-home__panel"
        v-if="
          $session.get('AccessMenu').filter((x) => x.id == 80).length > 0 &&
          $session.get('AccessMenu').filter((x) => x.id == 80)[0].isMenu
        "
      >
        <div class="card Netpa-Shadow bnp-rounded netpa-billpay-card">
          <div class="card-body text-right pb-5">
            <div class="row">
              <div class="col-12">
                <div class="row my-2 mx-md-5 mx-0 netpa-billpay-title-row">
                  <div
                    class="col-12 alert border border-dark text-ceneter netpa-billpay-title"
                  >
                    <h6 class="font-weight-bold mt-1 d-inline text-dark">
                      پرداخت قبوض از حساب
                    </h6>
                    <div class="mx-2 d-inline">
                      میتواند قبض های خود را به راحتی از حساب خود پرداخت کنید
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ghabz @indexSelected="openGhabz"></ghabz>
          </div>
        </div>
      </div>
    </div>
    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="netpa-tabloo-modal" dir="rtl">
          <div class="netpa-tabloo-modal__header">
            <time class="netpa-tabloo-modal__date">{{ NotifDate }}</time>
            <button
              type="button"
              class="netpa-tabloo-modal__close"
              data-dismiss="modal"
              aria-label="بستن"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <h6 class="netpa-tabloo-modal__title">{{ Notfheader }}</h6>
          <div class="netpa-tabloo-modal__body">{{ NotifTxt }}</div>
        </div>
      </template>
      <template v-slot:ContentModalBanafash>
        <div class="row" dir="rtl" style="max-height: 75vh; overflow-y: scroll">
          <div class="col-12 pr-0" v-for="(item, index) in Tabloo" :key="index">
            <div class="col-12 pr-0">
              <div class="col-12 py-1 mx-0 text-right">
                <i class="fas fa-comment-alt ml-2 text-info"></i>
                <span class="font-weight-bold">
                  {{ item.subjectTabloElanat }}</span
                >
                <span class="mr-3 float-left">{{ item.zamanInsert }} </span>
              </div>
              <div class="col-12 px-1 mt-2">
                <div class="row">
                  <div
                    class="col-12 text-justify"
                    style="max-width: 100%"
                    dir="rtl"
                  >
                    {{ item.txtMatnTabloElanat }}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:ContentModalSuccess>
        <debtor></debtor>
      </template>
      <template v-slot:ContentModalOrange>
        <div class="row">
          <div class="col-12">
            <div class="alert alert-secondary text-center">
              برای تایید ضمانت لطفا مدارک خواسته شده را آپلود و سپس نسبت به
              تایید ضمانت اقدام فرمایید
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div
              class="Uploader Pointer text-center py-3"
              @click="OpenUploader(1)"
            >
              <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
              <div class="mt-5">
                فایل <span class="text-warning"> حکم کارگزینی </span> خود را
                بارگذاری کنید
              </div>
              <small class="text-warning">( کلیک کنید )</small>
            </div>
            <input
              type="file"
              class="form-control d-none"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="FileHokm"
              @change="UploadFile($event, 1)"
            />
          </div>
          <div class="col-md-4 col-12">
            <div
              class="Uploader Pointer text-center py-3"
              @click="OpenUploader(2)"
            >
              <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
              <div class="mt-5">
                فایل <span class="text-warning"> فرم ضمــانت </span> خود را
                بارگذاری کنید
              </div>
              <small class="text-warning">( کلیک کنید )</small>
            </div>
            <input
              type="file"
              class="form-control d-none"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="FileZemanat"
              @change="UploadFile($event, 1)"
            />
          </div>
          <div class="col-md-4 col-12">
            <div
              class="Uploader Pointer text-center py-3"
              @click="OpenUploader(3)"
            >
              <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
              <div class="mt-5">
                فایل <span class="text-warning"> قرارداد وام </span> خود را
                بارگذاری کنید
              </div>
              <small class="text-warning">( کلیک کنید )</small>
            </div>
            <input
              type="file"
              class="form-control d-none"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="FileGhrardad"
              @change="UploadFile($event, 1)"
            />
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import ModalCustom from "../Tools/ModalCustom.vue";

import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import AccountsChart from "./Componenets/AccountsChart.vue";
import FundReserveChart from "./Componenets/FundReserveChart.vue";
import AllocatedProfitsChart from "./Componenets/AllocatedProfitsChart.vue";
import ProfitSettlementChart from "./Componenets/ProfitSettlementChart.vue";
import Debtor from "./Debtor.vue";
import Ghabz from "./Ghabz.vue";
export default {
  components: {
    NetPaCard,
    ModalCustom,
    Debtor,
    AccountsChart,
    FundReserveChart,
    ProfitSettlementChart,
    AllocatedProfitsChart,
    Ghabz,
  },
  data() {
    return {
      shenaseVariz: "",
      DataAxiosRowGetShenase: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/GetShenaseVariz",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosTabloo: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Tabloo",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosMarkAsRead: {
        ArryfildValue: "",
        Method: "Post",
        Action: "TablooElanat/MarkAsRead",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosReqNeedVam: {
        ArryfildValue: "",
        Method: "Post",
        Action: "TaeedZamen",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosMoavaghat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Moavaghaat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosChart: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosFastPaymnet: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Fastpayment",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
      ListReqNeedVam: [],
      Tabloo: "loading",
      Moavaghaat: null,
      Notfheader: "",
      NotifTxt: "",
      NotifDate: "",
      Mab: "0",
      ChartLoaded: "loading",
      FastpaymentData: [],
      SumMabFastPay: 0,
      SumJarmieFastPay: 0,
      VamCoutFastPay: 0,
      TablooLength: 0,
      SumMablagh: 0,
      chartData: {},
      series: [
        {
          name: "اقساط پرداخت شده",
          data: [],
        },
        {
          name: "اقساط پرداخت نشده",
          data: [],
        },
        {
          name:
            this.$GetIsAnbohSaz() == "false"
              ? "اقساط تسویه شده"
              : "قرارداد تسویه شده",
          data: [],
        },
        {
          name: "اقساط معوقه",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "40%",
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (val) {
              return val;
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
        colors: ["#435ebe", "#f89215", "#67b221", "#E52505"],
      },
      Dargah: null,
      accessMenu1: 0,
      accessMenu2: 0,
      accessMenu4: 0,
      accessMenu3: 0,
      accessMenuAccount: 0,
      accessMenuLoan: 0,
      accessMenuTurnover: 0,
      accessMenuTabloo: 0,
      accessMenuRequestLoan: 0,
      accessMenuOnlinePaymentReport: 0,
      IsUploadAttachZamen: false,
      fileInfo: null,
      needVam: 0,
      showReadOnly: false,

      /*k.hr scroll */
      quickAccessMenuItems: [
        {
          linkCondition: this.accessMenuAccount,
          linkTo: "Accounts",
          iconClass: "fas fa-wallet",
          text: "حساب ها",
        },
        {
          linkCondition: this.accessMenuLoan,
          linkTo: "loan",
          iconClass: "fas fa-hand-holding-usd",
          text: "تسهیلات",
        },
        {
          linkCondition: this.accessMenuTurnover,
          linkTo: "Turnover",
          iconClass: "fas fa-file-invoice",
          text: "صورت حساب",
        },
        {
          linkCondition: this.accessMenu1,
          linkTo: "Debtor",
          iconClass: "fas fa-arrow-up",
          text: "برداشت از حساب",
        },
        {
          linkCondition: this.accessMenu2,
          linkTo: {
            name: "Deposit",
            params: { IsShowComboHesab: true, IsTashilat: false },
          },
          iconClass: "fas fa-arrow-down",
          text:
            this.$session.get("IsTaavoniEtebar") == true
              ? "افزایش اعتبار"
              : "واریز به حساب",
        },
        {
          linkCondition: this.accessMenu3,
          linkTo: {
            name: "Deposit",
            params: { IsShowComboHesab: true, IsTashilat: true },
          },
          iconClass: "fas fa-receipt",
          text: "پرداخت اقساط",
        },
        {
          linkCondition: this.accessMenu4,
          linkTo: { name: "DepositGroup" },
          iconClass: "fas fa-coins",
          text: "پرداخت گروهی",
        },
        {
          linkCondition: this.accessMenuOnlinePaymentReport,
          linkTo: "OnlinePaymentReport",
          iconClass: "fas fa-chart-bar",
          text: "گزارش پرداخت اینترنتی",
        },
        {
          linkCondition: this.accessMenuRequestLoan,
          linkTo: { name: "RequestVamNew" },
          iconClass: "fas fa-file-signature",
          text: "درخواست وام",
        },
      ],
      scrollAmount: 0,
      isScrollable: false,
      canScrollLeft: false,
      canScrollRight: false,
      viewportWidth: 0,
      quickAccessResizeObserver: null,
      dashboardEditMode: false,
      dragWidgetId: null,
      dragWidgetSize: null,
      homeLayout: {
        mainOrder: ["fastpay", "loan"],
        sideOrder: ["tabloo", "quick"],
        fullOrder: ["zemanat", "moavaghaat"],
        chartOrder: ["accounts", "fund", "profit", "allocated"],
      },
    };
  },
  methods: {
    RqNeedVam(IdNeedVam, Status, NeedVamModel) {
      if (Status == 1) {
        this.$SweetQustion(
          "توجه",
          this.taeedZemantMessage(),
          "warning",
          "اطمینان دارم",
          "منصرف شدم",
          IdNeedVam,
          this.AcceptVam,
          this.Cancel,
        );
        this.needVam = NeedVamModel;
        this.GetTblNoeZamenPolicyOnline(NeedVamModel);
      }
      if (Status == 2) {
        this.$SweetQustion(
          "توجه",
          "از رد ضمانت خود اطمینان دارید؟",
          "warning",
          "اطمینان دارم",
          "منصرف شدم",
          IdNeedVam,
          this.UnAcceptVam,
          this.Cancel,
        );
      }
    },

    taeedZemantMessage() {
      let message = "";
      if (this.$session.get("CustCode") == "643") {
        message =
          ' اینجانبان امضاءکنندگان زیر بدینوسیله با آگاهی کامل از مقررات و آیین نامه های شرکت تعاونی اعتبار کارکنان خبرگزاری جمهوری اسلامی بطورانفرادی وام نامبرده را ضمانت نموده و متعهد می شویم چنانچه بازپرداخت وام ایشان به هر دلیلی به تعویق بیفتد بدون هیچ گونه عذر و بهانه اقساط وام فوق الذکر به انضمام کارمزد و هزینه های مربوطه را پرداخت نماییم.و ذیحسابی سازمان خبرگزاری جمهوری اسلامی وکالت بلاعزل دارد مبلغ اعلام شده از سوی شرکت تعاونی اعتبار را از حقوق و سایر مطالبات اینجانبان (هر گونه که صلاح میداند) تا تسویه کامل برداشت و به حساب بدهی نامبرده نزد شرکت تعاونی اعتبار مذکور واریز نماید. ضمنا" می پذیریم که ترتیب محل امضاء به معنی حق تقدم و اولویت در ابقای تعهد نیست .چنانچه وام گیرنده بازنشسته یا به هر دلیلی از سازمان تسویه نماید و عضویت تعاونی اعتبار خود را حفظ نماید ضمانت این فرم تا پایان تسویه وام اعتبار دارد.';
      } else {
        message = "از تایید ضمانت خود اطمینان دارید؟";
      }
      return message;
    },

    changefile() {
      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 1) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل مورد نظر بیشتر از 1 مگابایت است ",
          "error",
          3000,
        );
        return;
      }
      this.fileInfo = document.getElementById("Uploader").files[0];
      let DataAxiosUpload = {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/SaveAttachmentToDb",
        // P0-1 : server peyvast-e vam ra faghat ba token-e zamen/saheb-e vam mipazirad
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("IdEftetah", this.needVam.needVamId);
      formdata.append("Image", this.fileInfo);
      formdata.append("TableName", "wwwtblNeedVam");
      formdata.append("wwwtblcomboidgrp328", 181070523); //181070523 آیدی اتچ ضامنین
      DataAxiosUpload.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosUpload).then((data) => {
        //Save Change state zanen
        var UpdTaeedZemanat = {
          ArryfildValue: "",
          Method: "Post",
          Action: "UpdTaeedZemanat",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("Id", this.needVam.id);
        formData.append("Status", 1);
        UpdTaeedZemanat.ArryfildValue = formData;
        this.$PostFormData(UpdTaeedZemanat).then((data) => {
          if (data.success == "SUCCESS") {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "درخواست ضمانت باموفقیت تایید شد .",
              "success",
              2000,
            );
            this.$store.state.renderComponent = false;
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
            this.GetReqNeedVam();
          }
        });
      });
    },
    AcceptVam(id) {
      if (this.IsUploadAttachZamen) {
        const Time = 2000;
        this.$mySweetDefaultTost(
          "آپلود مدارک",
          "لطفا فایل مدارک ضمانت خود را  با در حالت فشارده (zip , rar) آپلود نمایید .",
          "warning",
          Time,
        );
        setTimeout(this.ShowUploaderzamen, Time);
      } else {
        //Save Change state zanen
        var UpdTaeedZemanat = {
          ArryfildValue: "",
          Method: "Post",
          Action: "UpdTaeedZemanat",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("Id", this.needVam.id);
        formData.append("Status", 1);
        UpdTaeedZemanat.ArryfildValue = formData;
        this.$PostFormData(UpdTaeedZemanat).then((data) => {
          if (data.success == "SUCCESS") {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "درخواست ضمانت باموفقیت تایید شد .",
              "success",
              2000,
            );
            this.$store.state.renderComponent = false;
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
            this.GetReqNeedVam();
          }
        });
      }
    },
    UnAcceptVam(id) {
      var UpdTaeedZemanat = {
        ArryfildValue: "",
        Method: "Post",
        Action: "UpdTaeedZemanat",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("Id", id);
      formData.append("Status", 2);
      UpdTaeedZemanat.ArryfildValue = formData;
      this.$PostFormData(UpdTaeedZemanat).then((data) => {
        if (data.success == "SUCCESS") {
          this.$mySweetDefaultTost(
            "عملیات موفق",
            "درخواست ضمانت باموفقیت رد شد .",
            "success",
            2000,
          );
          this.$store.state.renderComponent = false;
          this.$nextTick(() => {
            this.$store.state.renderComponent = true;
          });
          this.GetReqNeedVam();
        }
      });
    },
    ShowUploaderzamen() {
      document.getElementById("Uploader").click();
    },
    GetTblNoeZamenPolicyOnline(ModelNeedVam) {
      this.IsUploadAttachZamen = false;
      let DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetSettingVamAndPolicy",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("id", ModelNeedVam.noeId);
      DataAxios.ArryfildValue = formdata;
      this.$PostFormData(DataAxios).then((res) => {
        res.forEach((el) => {
          if (
            el.mabAz <= ModelNeedVam.mablagh &&
            el.mabTa >= ModelNeedVam.mablagh
          ) {
            this.IsUploadAttachZamen = el.isUpload;
          }
        });
      });
    },
    GetTablooElanat() {
      if (this.$session.get("CustCode") == "801") {
        const formData = new FormData();
        formData.append(
          "ShobeId",
          this.$session.get("UserInfoNetPa").wwwtblShobeId,
        );
        formData.append(
          "wwwtblTafsiliTypeId",
          this.$session.get("UserInfoNetPa").wwwtblTafsiliTypeId,
        );
        this.DataAxiosTabloo.ArryfildValue = formData;
        this.DataAxiosTabloo.Action = "Tabloo/GetTablooV2";
        this.$PostFormData(this.DataAxiosTabloo).then((data) => {
          this.Tabloo = data;
          this.TablooLength = this.Tabloo.length;
        });
      } else {
        const formData = new FormData();
        formData.append(
          "ShobeId",
          this.$session.get("UserInfoNetPa").wwwtblShobeId,
        );
        formData.append(
          "AzaNoId",
          this.$session.get("UserInfoNetPa").wwwtblAzaNoeId,
        );
        this.DataAxiosTabloo.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosTabloo).then((data) => {
          this.Tabloo = data;
          this.TablooLength = this.Tabloo.length;
        });
      }
    },
    GetReqNeedVam() {
      const formData = new FormData();
      formData.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formData.append("Today", this.$GetJalaliDate());
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      this.DataAxiosReqNeedVam.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosReqNeedVam).then((data) => {
        this.ListReqNeedVam = data;
      });
    },
    GetMoavaghat() {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      this.DataAxiosMoavaghat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosMoavaghat).then((data) => {
        this.Moavaghaat = data;

        if (data.length > 0) {
          var moavaghatNoeId = [];

          for (var i = 0; i < data.length; i++) {
            !moavaghatNoeId.includes(data[i].wwwtblNoeId) &&
              moavaghatNoeId.push(data[i].wwwtblNoeId);
          }
          this.$session.set("moavaghatNoeId", moavaghatNoeId);
        }

        this.$store.state.renderComponent = false;
        window.dispatchEvent(new Event("resize"));
        this.$nextTick(() => {
          this.$store.state.renderComponent = true;
        });
      });
    },
    ShowFullNotif(Notif) {
      this.Notfheader = Notif.subjectTabloElanat;
      this.NotifTxt = Notif.txtMatnTabloElanat;
      this.NotifDate = Notif.zamanInsert;
      // Mark as read in database
      const itemId =
        Notif.id ||
        Notif.bnpCashDbtblTabloElanatId ||
        Notif.BnpCashDbtblTabloElanatID;
      const azaId = this.$session.get("UserInfoNetPa").wwwtblAzaId;

      if (itemId && azaId && !Notif.isItemRead) {
        const formData = new FormData();
        formData.append("TabloElanatId", itemId);
        formData.append("AzaId", azaId);
        this.DataAxiosMarkAsRead.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosMarkAsRead)
          .then((data) => {
            if (data.success === true || data.Success === true) {
              Notif.isItemRead = true;
              this.GetTablooElanat();
            }
          })
          .catch(() => {
            // Silent fail - don't show error to user
          });
      }
    },
    toggleReadFilter() {
      this.showReadOnly = !this.showReadOnly;
    },
    markAsReadWithConfirm(item) {
      this.$swal({
        title: "علامت‌گذاری به عنوان خوانده شده",
        text: "آیا مطمئن هستید که این اعلان را به عنوان خوانده شده علامت‌گذاری کنید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله، مطمئنم",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          const itemId =
            item.id ||
            item.bnpCashDbtblTabloElanatId ||
            item.BnpCashDbtblTabloElanatID;
          const azaId = this.$session.get("UserInfoNetPa").wwwtblAzaId;

          if (itemId && azaId && !item.isItemRead) {
            const formData = new FormData();
            formData.append("TabloElanatId", itemId);
            formData.append("AzaId", azaId);
            this.DataAxiosMarkAsRead.ArryfildValue = formData;

            this.$PostFormData(this.DataAxiosMarkAsRead)
              .then((data) => {
                if (data.success === true || data.Success === true) {
                  item.isItemRead = true;
                  this.GetTablooElanat();
                  this.$mySweetDefaultTost(
                    "عملیات موفق",
                    "اعلان با موفقیت به عنوان خوانده شده علامت‌گذاری شد",
                    "success",
                    2000,
                  );
                } else {
                  this.$mySweetDefaultTost(
                    "خطا",
                    "خطایی در علامت‌گذاری اعلان رخ داد",
                    "error",
                    2000,
                  );
                }
              })
              .catch(() => {
                this.$mySweetDefaultTost(
                  "خطا",
                  "خطایی در علامت‌گذاری اعلان رخ داد",
                  "error",
                  2000,
                );
              });
          }
        }
      });
    },
    isItemRead(item) {
      return item.isItemRead === true || item.isItemRead === 1;
    },
    GetDataForChart() {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 1);
      this.DataAxiosChart.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosChart).then((data) => {
        this.chartData = data;
        this.TedadKolevmaha = data.length;
        data.forEach((element) => {
          if (element.mande != 0) {
            this.chartOptions.xaxis.categories.push(element.desNoe);
            this.series[0].data.push(element.tedadAghsatPardaxtShode);
            if (element.tedadMoavaghe > 0) {
              this.series[3].data.push(element.tedadMoavaghe);
              this.series[1].data.push(
                element.tedadAghsatPardaxtNaShode - element.tedadMoavaghe,
              );
            } else {
              this.series[3].data.push(0);
              this.series[1].data.push(element.tedadAghsatPardaxtNaShode);
            }

            this.series[2].data.push(0);
          } else {
            this.chartOptions.xaxis.categories.push(element.desNoe);

            this.series[0].data.push(0);
            this.series[1].data.push(0);
            this.series[3].data.push(0);
            this.series[2].data.push(element.tedadAghsatPardaxtShode);
          }
          // this.chartOptions.plotOptions.bar.barHeight = data.length==1? 0.1:0.4
        });
        this.ChartLoaded = "true";
        this.$store.state.renderComponent = false;
        window.dispatchEvent(new Event("resize"));
        this.$nextTick(() => {
          this.$store.state.renderComponent = true;
        });
      });
    },
    GetFastpaymentData() {
      if (this.$session.get("UserInfoNetPa").wwwtblAzaId) {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 1);
        this.DataAxiosFastPaymnet.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosFastPaymnet).then((data) => {
          if (data.data) {
            for (var i = 0; i < data.data.length; i++) {
              var element = data.data[i];
              data.data[i].Active = true;
              this.SumJarmieFastPay +=
                element.wwwjarime == null ? 0 : element.wwwjarime;
            }
            this.FastpaymentData = data.data;
            this.$store.state.renderComponent = false;
            window.dispatchEvent(new Event("resize"));
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
          }
        });
      } else {
        this.FastpaymentData = [];
      }
    },
    ShowAllNotifications() {},
    async Pay() {
      if (this.Dargah == null) {
        if (this.$session.get("CustCode") == 801) {
          this.$swal(
            "اختلال در پرداخت با درگاه",
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)",
            "warning",
          );
        } else {
          this.$mySweetDefaultTost(
            "عدم انتخاب درگاه",
            "درگاهی برای سامانه تنظیم نشده است",
            "warning",
            3000,
          );
        }
      } else {
        const WwwtblVarizGorohiRiz = [];
        for (
          let index = 0;
          index < this.TotalFastPay.listFastpay.length;
          index++
        ) {
          //  console.log('!!', this.TotalFastPay.listFastpay[index].vCode)
          WwwtblVarizGorohiRiz.push({
            WwwtblTaahodatId: this.TotalFastPay.listFastpay[index].id,
            Mablagh: this.TotalFastPay.listFastpay[index].mablghPardakht,
            SharhRiz:
              " پرداخت سریع قسط تسهیلات " +
              this.TotalFastPay.listFastpay[index].vCode,
            WwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
            BnpCashDbtblTaahodatId:
              this.TotalFastPay.listFastpay[index].bnpCashDBtblTaahodatId,
            BnpCashDBtblAzaId:
              this.$session.get("UserInfoNetPa").bnpCashDBtblAzaId,
            MablaghJarime:
              this.TotalFastPay.listFastpay[index].wwwjarime == null
                ? 0
                : this.TotalFastPay.listFastpay[index].wwwjarime,
            TarixGhest:
              this.TotalFastPay.listFastpay[index].minTarGhestBedehkar,
            MabReturnrKarmozd: 0,
            IsLinkPay: 0,
          });
          this.shenaseVariz = await this.GetShenase(
            this.TotalFastPay.listFastpay[index].vCode,
          );
        }
        this.SumMablagh = this.TotalFastPay.SumMabFastPay;
        this.DataAxios_Variz.ArryfildValue.Mablagh = this.SumMablagh;
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.Sharh = "پرداخت اقساط گروهی";
        this.DataAxios_Variz.ArryfildValue.ZamanInsert =
          this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(
          this.$session.get("UserInfoNetPa").custCode,
        );
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
          this.$session.get("UserInfoNetPa").wwwtblAzaId;
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
          WwwtblVarizGorohiRiz;
        //  console.log(this.DataAxios_Variz.ArryfildValue)
        this.$PostData(this.DataAxios_Variz).then((result) => {
          this.$Payment(
            JSON.stringify(this.Dargah),
            JSON.stringify(this.SumMablagh),
            this.$session.get("UserInfoNetPa").ozvName +
              " " +
              this.$session.get("UserInfoNetPa").ozvFamily,
            this.$session.get("UserInfoNetPa").email,
            this.$session.get("UserInfoNetPa").mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            this.shenaseVariz,
            this.TotalFastPay.listFastpay[0].vCode,
            "سبد اقساط",
            JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblAzaId),
            this.$session.get("UserInfoNetPa").custCode,
            JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblShobeId),
            result.idRepoMaster,
            this.$session.get("UserInfoNetPa").codeMeli,
            this.$session.get("UserInfoNetPa").ozvName +
              " " +
              this.$session.get("UserInfoNetPa").ozvFamily,
            this.$session.get("UserInfoNetPa").mobile,
            this.$session.get("UserInfoNetPa").codeMeli,
          );
        });
      }
    },
    async GetShenase(Vcode) {
      const formData = new FormData();
      formData.append("Vcode", Vcode);
      this.DataAxiosRowGetShenase.ArryfildValue = formData;
      // this.$PostFormData(this.DataAxiosRowGetShenase).then((data) => {
      //   return data;
      // });
      const data = await this.$PostFormData(this.DataAxiosRowGetShenase);
      return data;
    },
    OpenUploader(Type) {
      // Type 1= ExcelFile, Type 2=JsonFile
      if (Type == 1) {
        document.getElementById("FileHokm").click();
      }
      if (Type == 2) {
        document.getElementById("FileZemanat").click();
      }
      if (Type == 3) {
        document.getElementById("FileGhrardad").click();
      }
    },
    openGhabz(index) {
      this.$router.push({ name: "BillPayment", params: { indexMenu: index } });
    },
    /*k.hr quick access menu scroll methods*/
    getQuickAccessItems() {
      const container = this.$refs.scrollContainer;
      if (!container) return [];
      return Array.from(
        container.querySelectorAll(".netpa-quick-access__item"),
      );
    },

    calcMarginAndWidth() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const firstColumn = container.querySelector(".netpa-quick-access__item");
      if (!firstColumn) return;

      const rect = firstColumn.getBoundingClientRect();
      this.columnWidth = rect.width;
      const scrollStyle = window.getComputedStyle(container);
      const gap =
        parseFloat(scrollStyle.gap) || parseFloat(scrollStyle.columnGap) || 0;
      this.scrollAmount = this.columnWidth + gap || 110;
    },

    scrollQuickAccess(step) {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      if (step > 0 && !this.canScrollRight) return;
      if (step < 0 && !this.canScrollLeft) return;

      const items = this.getQuickAccessItems();
      if (!items.length) return;

      this.calcMarginAndWidth();
      const fallbackAmount = this.scrollAmount || 106;
      const containerRect = container.getBoundingClientRect();
      const edgeGap = 4;
      let scrollDelta = 0;

      if (step > 0) {
        const target = items.find(
          (item) =>
            item.getBoundingClientRect().right > containerRect.right + edgeGap,
        );
        scrollDelta = target
          ? target.getBoundingClientRect().right - containerRect.right
          : fallbackAmount;
      } else {
        const target = [...items]
          .reverse()
          .find(
            (item) =>
              item.getBoundingClientRect().left < containerRect.left - edgeGap,
          );
        scrollDelta = target
          ? target.getBoundingClientRect().left - containerRect.left
          : -fallbackAmount;
      }

      const isRtl = window.getComputedStyle(container).direction === "rtl";
      if (isRtl) {
        scrollDelta = -scrollDelta;
      }

      container.scrollBy({
        left: scrollDelta,
        behavior: "smooth",
      });

      window.setTimeout(() => this.updateScrollability(), 400);
    },

    scrollLeft() {
      this.scrollQuickAccess(-1);
    },
    scrollRight() {
      this.scrollQuickAccess(1);
    },
    updateScrollability() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const items = this.getQuickAccessItems();
      if (!items.length) {
        this.isScrollable = false;
        this.canScrollLeft = false;
        this.canScrollRight = false;
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const edgeGap = 2;

      const hasHiddenLeft = items.some(
        (item) =>
          item.getBoundingClientRect().left < containerRect.left - edgeGap,
      );
      const hasHiddenRight = items.some(
        (item) =>
          item.getBoundingClientRect().right > containerRect.right + edgeGap,
      );

      this.isScrollable =
        hasHiddenLeft ||
        hasHiddenRight ||
        container.scrollWidth > container.clientWidth + 1;

      this.canScrollRight = hasHiddenRight;
      this.canScrollLeft = hasHiddenLeft;
    },
    // Method to handle window resize
    handleResize() {
      this.viewportWidth = window.innerWidth;
      this.calcMarginAndWidth();
      this.updateScrollability();
    },

    observeQuickAccessResize() {
      const container = this.$refs.scrollContainer;
      if (!container || typeof ResizeObserver === "undefined") return;

      if (this.quickAccessResizeObserver) {
        this.quickAccessResizeObserver.disconnect();
      }

      this.quickAccessResizeObserver = new ResizeObserver(() => {
        this.updateScrollability();
      });
      this.quickAccessResizeObserver.observe(container);
    },
    defaultHomeLayout() {
      return {
        mainOrder: ["fastpay", "loan"],
        sideOrder: ["tabloo", "quick"],
        fullOrder: ["zemanat", "moavaghaat"],
        chartOrder: ["accounts", "fund", "profit", "allocated"],
      };
    },
    homeLayoutStorageKey() {
      const cust = this.$session.get("CustCode") || "0";
      return "netpa-home-layout-v4:" + cust;
    },
    applySavedLayout(saved) {
      const defaults = this.defaultHomeLayout();
      const allIds = [
        "fastpay",
        "loan",
        "tabloo",
        "quick",
        "zemanat",
        "moavaghaat",
        "accounts",
        "fund",
        "profit",
        "allocated",
      ];
      const lists = ["fullOrder", "mainOrder", "sideOrder", "chartOrder"];
      const used = {};
      const result = {
        fullOrder: [],
        mainOrder: [],
        sideOrder: [],
        chartOrder: [],
      };
      lists.forEach((name) => {
        (Array.isArray(saved[name]) ? saved[name] : []).forEach((id) => {
          if (allIds.includes(id) && !used[id]) {
            result[name].push(id);
            used[id] = true;
          }
        });
      });
      lists.forEach((name) => {
        defaults[name].forEach((id) => {
          if (!used[id]) {
            result[name].push(id);
            used[id] = true;
          }
        });
      });
      return result;
    },
    mergeWidgetOrder(saved, defaults) {
      const next = (Array.isArray(saved) ? saved : []).filter((id) =>
        defaults.includes(id)
      );
      defaults.forEach((id) => {
        if (!next.includes(id)) next.push(id);
      });
      return next;
    },
    loadHomeLayout() {
      const defaults = this.defaultHomeLayout();
      try {
        const raw = window.localStorage.getItem(this.homeLayoutStorageKey());
        if (!raw) {
          this.homeLayout = defaults;
          return;
        }
        const saved = JSON.parse(raw);
        this.homeLayout = this.applySavedLayout(saved);
      } catch (e) {
        this.homeLayout = defaults;
      }
    },
    saveHomeLayout() {
      try {
        window.localStorage.setItem(
          this.homeLayoutStorageKey(),
          JSON.stringify(this.homeLayout)
        );
      } catch (e) {
        /* ignore quota / private mode */
      }
    },
    resetHomeLayout() {
      this.homeLayout = this.defaultHomeLayout();
      this.dashboardEditMode = false;
      this.dragWidgetId = null;
      try {
        window.localStorage.removeItem(this.homeLayoutStorageKey());
      } catch (e) {
        /* ignore */
      }
    },
    toggleDashboardEdit() {
      if (this.dashboardEditMode) {
        this.saveHomeLayout();
        this.dashboardEditMode = false;
        this.dragWidgetId = null;
        return;
      }
      this.dashboardEditMode = true;
    },
    widgetStyle(id) {
      const full = this.orderedVisible("fullOrder");
      const main = this.orderedVisible("mainOrder");
      const side = this.orderedVisible("sideOrder");
      const charts = this.orderedVisible("chartOrder");
      if (charts.includes(id)) {
        return { order: charts.indexOf(id) + 1 };
      }
      const stacked = this.viewportWidth > 0 && this.viewportWidth < 992;
      const singleColumn = stacked || !this.dashboardHasTwoColumns;
      if (singleColumn) {
        const all = full.concat(main).concat(side);
        const index = all.indexOf(id);
        return {
          gridColumn: "1",
          gridRow: String((index >= 0 ? index : 0) + 1),
        };
      }
      if (full.includes(id)) {
        return {
          gridColumn: "1 / -1",
          gridRow: String(full.indexOf(id) + 1),
        };
      }
      const rowOffset = full.length;
      if (side.includes(id)) {
        return {
          gridColumn: "2",
          gridRow: String(rowOffset + side.indexOf(id) + 1),
        };
      }
      const mainIndex = main.indexOf(id);
      return {
        gridColumn: "1",
        gridRow: String(rowOffset + (mainIndex >= 0 ? mainIndex : 0) + 1),
      };
    },
    widgetOrder(id) {
      const lists = [
        this.homeLayout.fullOrder,
        this.homeLayout.mainOrder,
        this.homeLayout.sideOrder,
        this.homeLayout.chartOrder,
      ];
      for (let i = 0; i < lists.length; i++) {
        const index = (lists[i] || []).indexOf(id);
        if (index >= 0) return index + 1;
      }
      return 0;
    },
    orderedVisible(listName) {
      return (this.homeLayout[listName] || []).filter((id) =>
        this.isWidgetVisible(id)
      );
    },
    isWidgetVisible(id) {
      if (id === "fastpay") return !!this.showFastPay;
      if (id === "loan") return !!this.accessMenuLoan;
      if (id === "tabloo") return !!this.showTablooElanatCard;
      if (id === "quick") return this.visibleQuickAccessItems.length > 0;
      if (id === "zemanat") {
        return !!(this.ListReqNeedVam && this.ListReqNeedVam.length);
      }
      if (id === "moavaghaat") {
        return !!(this.Moavaghaat && this.Moavaghaat.length);
      }
      if (
        id === "accounts" ||
        id === "fund" ||
        id === "profit" ||
        id === "allocated"
      ) {
        return !!this.showSpecialCharts;
      }
      return false;
    },
    listNameForWidget(id) {
      const names = ["fullOrder", "mainOrder", "sideOrder", "chartOrder"];
      for (let i = 0; i < names.length; i++) {
        if ((this.homeLayout[names[i]] || []).includes(id)) return names[i];
      }
      return "mainOrder";
    },
    moveWidget(fromId, targetId) {
      const fromList = this.listNameForWidget(fromId);
      const toList = this.listNameForWidget(targetId);
      if (fromList === toList) {
        this.swapWidgetOrder(fromList, fromId, targetId);
        return;
      }
      const source = this.homeLayout[fromList].filter((id) => id !== fromId);
      const target = this.homeLayout[toList].slice();
      const targetIndex = target.indexOf(targetId);
      target.splice(targetIndex < 0 ? target.length : targetIndex, 0, fromId);
      this.homeLayout[fromList] = source;
      this.homeLayout[toList] = target;
    },
    swapWidgetOrder(listName, fromId, toId) {
      const list = this.homeLayout[listName].slice();
      const fromIndex = list.indexOf(fromId);
      const toIndex = list.indexOf(toId);
      if (fromIndex < 0 || toIndex < 0) return;
      const moved = list.splice(fromIndex, 1)[0];
      list.splice(toIndex, 0, moved);
      this.homeLayout[listName] = list;
    },
    onWidgetDragStart(event) {
      if (!this.dashboardEditMode) {
        event.preventDefault();
        return;
      }
      this.dragWidgetId = event.currentTarget.dataset.widget;
      this.dragWidgetSize = event.currentTarget.dataset.size;
      event.currentTarget.classList.add("is-dragging");
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", this.dragWidgetId || "");
    },
    onWidgetDragOver(event) {
      if (!this.dashboardEditMode || !this.dragWidgetId) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
    },
    onWidgetDrop(event) {
      event.preventDefault();
      const targetId = event.currentTarget.dataset.widget;
      const targetSize = event.currentTarget.dataset.size;
      const fromId = this.dragWidgetId;
      const fromSize = this.dragWidgetSize;
      this.dragWidgetId = null;
      this.dragWidgetSize = null;
      if (!fromId || fromId === targetId) return;
      this.moveWidget(fromId, targetId);
    },
    onWidgetDragEnd(event) {
      event.currentTarget.classList.remove("is-dragging");
      this.dragWidgetId = null;
      this.dragWidgetSize = null;
    },
    onSlotDragOver(event) {
      if (!this.dashboardEditMode || !this.dragWidgetId) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
    },
    onSlotDrop(event) {
      event.preventDefault();
      const listName = event.currentTarget.dataset.list;
      const visibleIndex = Number(event.currentTarget.dataset.index);
      const fromId = this.dragWidgetId;
      this.dragWidgetId = null;
      this.dragWidgetSize = null;
      if (!fromId || !listName || isNaN(visibleIndex)) return;
      this.insertWidgetAt(listName, fromId, visibleIndex);
    },
    insertWidgetAt(listName, fromId, visibleIndex) {
      const fromList = this.listNameForWidget(fromId);
      const original = (this.homeLayout[fromList] || []).slice();
      const targetOriginal =
        fromList === listName ? original : (this.homeLayout[listName] || []).slice();
      let listIndex = targetOriginal.length;
      let seen = 0;
      for (let i = 0; i < targetOriginal.length; i++) {
        if (!this.isWidgetVisible(targetOriginal[i])) continue;
        if (seen === visibleIndex) {
          listIndex = i;
          break;
        }
        seen++;
      }
      if (fromList === listName) {
        const fromPos = original.indexOf(fromId);
        if (fromPos >= 0 && fromPos < listIndex) listIndex -= 1;
      }
      const targetBase = targetOriginal.filter((id) => id !== fromId);
      if (listIndex < 0) listIndex = 0;
      if (listIndex > targetBase.length) listIndex = targetBase.length;
      targetBase.splice(listIndex, 0, fromId);
      if (fromList !== listName) {
        this.homeLayout[fromList] = original.filter((id) => id !== fromId);
      }
      this.homeLayout[listName] = targetBase;
    },
  },
  mounted() {
    this.loadHomeLayout();
    this.accessMenuAccount = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 5)[0].isMenu;
    this.quickAccessMenuItems[0].linkCondition = this.accessMenuAccount;

    this.accessMenuLoan = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 9)[0].isMenu;
    this.quickAccessMenuItems[1].linkCondition = this.accessMenuLoan;

    this.accessMenuTurnover = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 6)[0].isMenu;
    this.quickAccessMenuItems[2].linkCondition = this.accessMenuTurnover;

    this.accessMenu1 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 13)[0].isMenu;
    this.quickAccessMenuItems[3].linkCondition = this.accessMenu1;

    this.accessMenu2 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 7)[0].isMenu;
    this.quickAccessMenuItems[4].linkCondition = this.accessMenu2;

    this.accessMenu3 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 11)[0].isMenu;
    this.quickAccessMenuItems[5].linkCondition = this.accessMenu3;

    this.accessMenu4 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 20)[0].isMenu;
    this.quickAccessMenuItems[6].linkCondition = this.accessMenu4;

    this.accessMenuOnlinePaymentReport = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 19)[0].isMenu;
    this.quickAccessMenuItems[7].linkCondition =
      this.accessMenuOnlinePaymentReport;

    this.accessMenuRequestLoan = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 33)[0].isMenu;
    this.quickAccessMenuItems[8].linkCondition = this.accessMenuRequestLoan;

    this.accessMenuTabloo = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 82)[0].isMenu;

    //   this.accessMenu1=true
    //   this.accessMenu2=true
    //   this.accessMenu3=true
    //   this.accessMenu4=true
    //خواندن اطلاعات درگاه از دیتابیس
    this.$Gateway().then((data) => {
      if (data.status == "Ok") {
        data.data.forEach((element) => {
          if (
            (element.gatewayCode != null || element.gatewayCode != "") &&
            element.isDefault == true
          ) {
            this.Dargah = element.id;
          }
        });
      } else {
        this.$mySweetDefaultTost("عدم وجود اطلاعات", data.msg, "warning", 2000);
      }
    });

    this.GetFastpaymentData();
    this.GetDataForChart();

    /*k.hr*/
    this.viewportWidth = window.innerWidth;
    this.$nextTick(() => {
      this.$nextTick(() => {
        this.calcMarginAndWidth();
        this.updateScrollability();
        this.observeQuickAccessResize();
      });
    });
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.quickAccessResizeObserver) {
      this.quickAccessResizeObserver.disconnect();
      this.quickAccessResizeObserver = null;
    }
  },
  computed: {
    TotalFastPay() {
      var shomarande = 0;
      var SumMabFastPay = 0;
      var VamCoutFastPay = 0;
      var SumJarmieFastPay = 0;
      var listFastpay = [];
      for (let index = 0; index < this.FastpaymentData.length; index++) {
        const element = this.FastpaymentData[index];
        if (element.Active) {
          shomarande++;
          SumMabFastPay += element.mablghPardakht;
          SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime;
          listFastpay.push(element);
        }
      }
      VamCoutFastPay = shomarande;
      return {
        VamCoutFastPay: VamCoutFastPay,
        SumJarmieFastPay: SumJarmieFastPay,
        SumMabFastPay: SumMabFastPay,
        listFastpay: listFastpay,
      };
    },
    filteredTabloo() {
      if (this.Tabloo === "loading" || !Array.isArray(this.Tabloo)) {
        return this.Tabloo;
      }

      if (this.showReadOnly) {
        // نمایش فقط آیتم‌های خوانده شده
        return this.Tabloo.filter((item) => {
          return item.isItemRead === true || item.isItemRead === 1;
        });
      } else {
        // نمایش فقط آیتم‌های خوانده نشده
        return this.Tabloo.filter((item) => {
          return !(item.isItemRead === true || item.isItemRead === 1);
        });
      }
    },
    filteredTablooLength() {
      if (this.Tabloo === "loading" || !Array.isArray(this.Tabloo)) {
        return 0;
      }
      return this.filteredTabloo.length;
    },
    showTablooElanatCard() {
      return this.accessMenuTabloo;
    },
    showSideStack() {
      return (
        this.showTablooElanatCard || this.visibleQuickAccessItems.length > 0
      );
    },
    showMainStack() {
      return this.showFastPay || this.accessMenuLoan;
    },
    showDashboard() {
      return this.showMainStack || this.showSideStack;
    },
    showHomeBoard() {
      return (
        this.showDashboard ||
        this.showSpecialCharts ||
        this.orderedVisible("chartOrder").length > 0 ||
        (this.ListReqNeedVam && this.ListReqNeedVam.length != 0) ||
        (this.Moavaghaat && this.Moavaghaat.length != 0)
      );
    },
    dashboardHasTwoColumns() {
      if (this.viewportWidth > 0 && this.viewportWidth < 992) return false;
      if (this.dashboardEditMode) return true;
      const main = this.orderedVisible("mainOrder");
      const side = this.orderedVisible("sideOrder");
      return main.length > 0 && side.length > 0;
    },
    dashboardHasFullRow() {
      return this.boardColumns.some((col) => col.kind === "full");
    },
    dashboardHasChartsRow() {
      return this.boardColumns.some((col) => col.kind === "charts");
    },
    boardColumns() {
      const editing = this.dashboardEditMode;
      const mobile = this.viewportWidth > 0 && this.viewportWidth < 992;
      const full = this.orderedVisible("fullOrder");
      const main = this.orderedVisible("mainOrder");
      const side = this.orderedVisible("sideOrder");
      const cols = [];
      if (full.length || editing) {
        cols.push({ name: "fullOrder", kind: "full", ids: full });
      }
      if (main.length || (editing && !mobile)) {
        cols.push({ name: "mainOrder", kind: "main", ids: main });
      }
      if (side.length || (editing && !mobile)) {
        cols.push({ name: "sideOrder", kind: "side", ids: side });
      }
      const charts = this.orderedVisible("chartOrder");
      if (charts.length || editing) {
        cols.push({ name: "chartOrder", kind: "charts", ids: charts });
      }
      if (mobile && !main.length && !side.length && editing) {
        cols.push({ name: "mainOrder", kind: "main", ids: [] });
      }
      return cols;
    },
    showFastPay() {
      try {
        const menu = this.$session.get("AccessMenu") || [];
        const item = menu.filter((x) => x.id == 32)[0];
        return (
          this.FastpaymentData &&
          this.FastpaymentData.length != 0 &&
          item &&
          item.isMenu
        );
      } catch (e) {
        return false;
      }
    },
    showSpecialCharts() {
      const custCode = this.$session.get("CustCode");
      return custCode == 8002 || custCode == 898;
    },
    visibleQuickAccessItems() {
      return this.quickAccessMenuItems.filter((item) => item.linkCondition);
    },
    isQuickAccessExpanded() {
      return this.viewportWidth < 768 && !this.isScrollable;
    },
    showQuickAccessNav() {
      return this.viewportWidth >= 768 || this.isScrollable;
    },
  },
  updated() {
    this.$PutCommatoInput();
    this.accessMenu1 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 13)[0].isMenu;
    this.accessMenu2 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 7)[0].isMenu;
    this.accessMenu3 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 11)[0].isMenu;
    this.accessMenuRequestLoan = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 33)[0].isMenu;

    this.accessMenuOnlinePaymentReport = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 19)[0].isMenu;
  },
  created() {
    this.GetReqNeedVam();
    this.GetTablooElanat();
    this.GetMoavaghat();
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0,
    );
    if (vw < 1080) {
      this.chartOptions.plotOptions.bar.horizontal = false;
      this.chartOptions.chart.height = 550;
      this.chartOptions.chart.width = 50;
    }
  },
};
</script>

<style scoped>
.max-h-15 {
  max-height: 8vh !important;
  overflow-y: hidden;
}
.textVerticalCenter {
  position: absolute;
  top: 30%;
  white-space: nowrap;
  right: 15%;
}
.bg-dark {
  background: #2a3f54 !important;
}
.border-danger {
  border-right: 2px solid #d10000 !important;
}
.badge-success {
  background: #67b221 !important;
  border-radius: 15px;
}
.btn-outline-dark:hover {
  background: none;
  color: rgb(41, 41, 41) !important;
}
.scroll_btn {
  background: #fff;
  cursor: pointer;
}

.scrl-r:active {
  box-shadow: -15px 1px 12px -7px #e8e8e8;
  border: none;
}

.scrl-l:active {
  box-shadow: 15px 1px 12px -7px #e8e8e8;
  border: none;
}
</style>
<style>
.netpa-home {
  --netpa-home-gap: 16px;
  --nh-navy: #29345f;
  --nh-blue: #287db4;
  --nh-cyan: #05b8c8;
  --nh-purple: #8d58a4;
  --nh-border: #e1e8ee;
  --nh-text: #13243a;
  --nh-muted: #6b7b8e;
  --nh-soft: #94a1b2;
  --nh-surface: #ffffff;
  --nh-soft-bg: #f8fafc;
  --nh-radius: 30px;
  --nh-shadow: 0 8px 24px rgba(31, 42, 79, 0.07);
  padding-top: 8px;
  padding-bottom: 28px;
}

.netpa-home .card,
.netpa-home .netpa-card,
.netpa-home .bnp-rounded,
.netpa-home__toolbar-btn,
.netpa-home__drop-slot,
.netpa-fastpay,
.netpa-fastpay__hero,
.netpa-fastpay__list-wrap,
.netpa-fastpay__btn,
.netpa-fastpay__item,
.netpa-quick__action,
.netpa-quick__icon,
.netpa-notice__btn,
.netpa-overdue,
.netpa-overdue__link,
.netpa-tabloo-modal,
.netpa-tabloo-modal__close,
.netpa-billpay-card,
.netpa-home .badge-success {
  corner-shape: squircle;
}

.netpa-home .card,
.netpa-home .netpa-card,
.netpa-home .bnp-rounded,
.netpa-billpay-card {
  border-radius: 36px !important;
}

.netpa-home__layout {
  display: flex;
  flex-direction: column;
  gap: var(--netpa-home-gap);
  width: 100%;
  max-width: 1480px;
  margin: 0 auto;
}

.netpa-home__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.netpa-home__toolbar-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 14px;
  border: 1px solid var(--nh-border);
  border-radius: 22px;
  background: #fff;
  color: var(--nh-navy);
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(31, 42, 79, 0.05);
}

.netpa-home__toolbar-btn i {
  color: var(--nh-blue);
  font-size: 14px;
}

.netpa-home__toolbar-btn.is-active {
  color: #fff;
  border-color: transparent;
  background: linear-gradient(110deg, #05b8c8, #287db4 55%, #56508d);
}

.netpa-home__toolbar-btn.is-active i {
  color: #fff;
}

.netpa-home__toolbar-btn--ghost {
  background: #f8fafc;
  font-weight: 700;
}

.netpa-home__toolbar-hint {
  color: var(--nh-muted);
  font-size: 12px;
}

.netpa-home.is-editing .netpa-home__widget {
  animation: netpa-widget-shake 0.32s ease-in-out infinite;
  cursor: grab;
  touch-action: none;
}

.netpa-home.is-editing .netpa-home__widget:nth-child(2n) {
  animation-delay: 0.08s;
}

.netpa-home.is-editing .netpa-home__widget:nth-child(3n) {
  animation-delay: 0.14s;
}

.netpa-home.is-editing .netpa-home__widget.is-dragging {
  animation: none;
  cursor: grabbing;
  opacity: 0.72;
  z-index: 3;
}

.netpa-home.is-editing .netpa-home__widget .card,
.netpa-home.is-editing .netpa-home__widget .netpa-card,
.netpa-home.is-editing .netpa-home__widget a,
.netpa-home.is-editing .netpa-home__widget button,
.netpa-home.is-editing .netpa-home__widget input,
.netpa-home.is-editing .netpa-home__widget label {
  pointer-events: none;
}

@keyframes netpa-widget-shake {
  0% {
    transform: rotate(-0.45deg);
  }
  50% {
    transform: rotate(0.45deg);
  }
  100% {
    transform: rotate(-0.45deg);
  }
}

.netpa-home__columns {
  align-items: start;
}

.netpa-home__stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.netpa-home__stack--full {
  grid-column: 1 / -1;
}

.netpa-home__stack--main {
  grid-column: 1;
}

.netpa-home__stack--side {
  grid-column: 2;
}

.netpa-home__cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.netpa-home__stack--charts {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--netpa-home-gap);
  align-items: stretch;
  width: 100%;
}

.netpa-home__stack--charts > .netpa-home__cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  height: 100%;
}

.netpa-home__stack--charts .netpa-home__panel--chart {
  flex: 1 1 auto;
  height: 100%;
}

.netpa-home__widget {
  container-type: inline-size;
  container-name: netpa-card;
}

@container netpa-card (max-width: 760px) {
  .netpa-fastpay__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@container netpa-card (max-width: 460px) {
  .netpa-fastpay__hero {
    padding: 14px 12px 12px;
  }

  .netpa-fastpay__fields {
    grid-template-columns: 1fr;
  }

  .netpa-fastpay__hero-words {
    font-size: 11px;
  }
}

.netpa-home.is-editing .netpa-home__dashboard--with-side {
  align-items: stretch;
}

.netpa-home.is-editing .netpa-home__stack {
  align-self: stretch;
}

.netpa-home__dashboard:not(.netpa-home__dashboard--with-side) .netpa-home__stack--main,
.netpa-home__dashboard:not(.netpa-home__dashboard--with-side) .netpa-home__stack--side,
.netpa-home__dashboard:not(.netpa-home__dashboard--with-side) .netpa-home__stack--full,
.netpa-home__dashboard:not(.netpa-home__dashboard--with-side) .netpa-home__stack--charts {
  grid-area: auto;
  grid-column: 1;
}

.netpa-home__drop-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 12px;
  border: 1.5px dashed #9eb4c4;
  border-radius: 28px;
  background: rgba(237, 245, 251, 0.7);
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
}

.netpa-home.is-editing .netpa-home__stack > .netpa-home__drop-slot:last-child {
  flex: 1 1 auto;
  min-height: 96px;
}

.netpa-home.is-editing .netpa-home__stack--charts > .netpa-home__drop-slot:last-child {
  grid-column: 1 / -1;
  flex: none;
  min-height: 72px;
}

.netpa-home__drop-slot:hover {
  border-color: #287db4;
  background: #edf7fb;
  color: #29345f;
}

.netpa-home__dashboard > .netpa-home__widget {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  justify-self: stretch;
}

.netpa-home__panel {
  min-width: 0;
  width: 100%;
}

.netpa-home__dashboard {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--netpa-home-gap);
  align-items: start;
}

.netpa-home__dashboard--with-side {
  grid-template-columns: minmax(0, 1.55fr) minmax(300px, 0.8fr);
  grid-template-areas: "main side";
}

.netpa-home__dashboard--with-side.netpa-home__dashboard--has-full {
  grid-template-areas:
    "full full"
    "main side";
}

.netpa-home__dashboard--with-side.netpa-home__dashboard--has-charts {
  grid-template-areas:
    "main side"
    "charts charts";
}

.netpa-home__dashboard--with-side.netpa-home__dashboard--has-full.netpa-home__dashboard--has-charts {
  grid-template-areas:
    "full full"
    "main side"
    "charts charts";
}

.netpa-home__dashboard--with-side .netpa-home__stack--full {
  grid-area: full;
}

.netpa-home__dashboard--with-side .netpa-home__stack--main {
  grid-area: main;
}

.netpa-home__dashboard--with-side .netpa-home__stack--side {
  grid-area: side;
}

.netpa-home__dashboard--with-side .netpa-home__stack--charts {
  grid-area: charts;
}

.netpa-home__main-stack,
.netpa-home__side-stack {
  display: flex;
  flex-direction: column;
  gap: var(--netpa-home-gap);
  min-width: 0;
  align-self: start;
}

.netpa-home__panel {
  min-width: 0;
  width: 100%;
}

.netpa-home__panel > .card.Netpa-Shadow.bnp-rounded,
.netpa-home__panel > .netpa-card,
.netpa-home__side-stack > .card.Netpa-Shadow.bnp-rounded,
.netpa-home__side-stack > .netpa-card {
  margin: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}

.netpa-home__charts-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--netpa-home-gap);
  align-items: stretch;
}

.netpa-home__panel--chart {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.netpa-home__panel--chart > .card.Netpa-Shadow.bnp-rounded,
.netpa-home__panel--chart > .netpa-card {
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.netpa-home__panel--chart .card-body,
.netpa-home__panel--chart .netpa-card__body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.netpa-overdue {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr) minmax(0, 1.3fr) auto auto;
  gap: 10px 14px;
  align-items: center;
  margin: 8px 4px;
  padding: 12px 14px;
  border: 1px solid var(--nh-border);
  border-radius: 24px;
  background: #fff;
}

.netpa-overdue__cell {
  min-width: 0;
  text-align: center;
}

.netpa-overdue__label,
.netpa-overdue__meta,
.netpa-overdue__value {
  display: block;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.netpa-overdue__label {
  color: #6c757d;
  font-size: 13px;
}

.netpa-overdue__meta {
  color: #536579;
  font-size: 13px;
}

.netpa-overdue__value {
  color: #dc3545;
  font-size: 16px;
  font-weight: 800;
}

.netpa-overdue__value small {
  color: #6c757d;
  font-size: 12px;
  font-weight: 600;
}

.netpa-overdue__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 6px 12px;
  border: 1px solid rgba(86, 80, 141, 0.28);
  border-radius: 16px;
  color: #56508d;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  background: #f4eef8;
}

.netpa-overdue__link:hover {
  color: #fff;
  text-decoration: none;
  border-color: #56508d;
  background: #56508d;
}

@container netpa-card (max-width: 720px) {
  .netpa-overdue {
    grid-template-columns: 1fr 1fr;
  }

  .netpa-overdue__cell--action {
    grid-column: 1 / -1;
  }
}

@container netpa-card (max-width: 460px) {
  .netpa-overdue {
    grid-template-columns: 1fr;
    text-align: right;
  }

  .netpa-overdue__cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    text-align: right;
  }

  .netpa-overdue__label,
  .netpa-overdue__meta,
  .netpa-overdue__value {
    text-align: right;
  }

  .netpa-overdue__value {
    font-size: 15px;
  }
}

/* Fast pay — hero + list as one card unit */
.netpa-fastpay {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  margin: -4px 0;
  overflow: hidden;
  border: 1px solid var(--nh-border);
  border-radius: 28px;
  background: #f8fafc;
}

.netpa-fastpay__hero {
  position: relative;
  padding: 20px 18px 18px;
  overflow: hidden;
  color: #fff;
  border-radius: 26px 26px 0 0;
  background:
    radial-gradient(
      circle at 10% 15%,
      rgba(5, 184, 200, 0.3),
      transparent 28%
    ),
    radial-gradient(
      circle at 92% 88%,
      rgba(141, 88, 164, 0.32),
      transparent 34%
    ),
    linear-gradient(145deg, #40437a, #29345f 58%, #1f244a);
}

.netpa-fastpay__hero::before,
.netpa-fastpay__hero::after {
  position: absolute;
  content: "";
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  pointer-events: none;
}

.netpa-fastpay__hero::before {
  top: -100px;
  left: -60px;
  width: 220px;
  height: 220px;
}

.netpa-fastpay__hero::after {
  right: -80px;
  bottom: -110px;
  width: 260px;
  height: 260px;
}

.netpa-fastpay__hero-top {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 13px;
  font-weight: 700;
}

.netpa-fastpay__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  color: #e7fbff;
  font-size: 12px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.1);
}

.netpa-fastpay__hero-label {
  position: relative;
  z-index: 1;
  display: block;
  margin-bottom: 6px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
}

.netpa-fastpay__hero-amount {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
  color: #fff;
  font-size: 22px;
  font-size: clamp(18px, 5.6vw, 26px);
  font-weight: 800;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.netpa-fastpay__hero-amount small {
  font-size: 12px;
  font-weight: 500;
  opacity: 0.8;
}

.netpa-fastpay__hero-words {
  position: relative;
  z-index: 1;
  margin: 6px 0 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 1.7;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.netpa-fastpay__hero-meta {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
  margin: 14px 0 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
}

.netpa-fastpay__hero-meta b {
  color: #fff;
  font-weight: 800;
}

.netpa-fastpay__btn {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 11px 14px;
  border: 0;
  border-radius: 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  background: linear-gradient(110deg, #05b8c8, #287db4 55%, #56508d);
  box-shadow: 0 8px 20px rgba(5, 184, 200, 0.25);
}

.netpa-fastpay__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.netpa-fastpay__list-wrap {
  padding: 12px 12px 14px;
  border-top: 0;
  background: #f8fafc;
  border-radius: 0 0 26px 26px;
}

.netpa-fastpay__list-label {
  margin-bottom: 10px;
  padding: 0 4px;
  color: var(--nh-navy);
  font-size: 13px;
  font-weight: 800;
}

.netpa-fastpay__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 280px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.netpa-fastpay__item {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 11px 12px;
  border: 1px solid var(--nh-border);
  border-right: 3px solid #c2cfd8;
  border-radius: 22px;
  background: #fff;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.netpa-fastpay__item.is-active {
  border-right-color: var(--nh-cyan);
  box-shadow: 0 3px 12px rgba(31, 42, 79, 0.07);
}

.netpa-fastpay__check {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin: 0;
  color: var(--nh-muted);
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.netpa-fastpay__check input {
  width: 18px;
  height: 18px;
  accent-color: var(--nh-blue);
  cursor: pointer;
}

.netpa-fastpay__fields {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-columns: repeat(auto-fit, minmax(7.25rem, 1fr));
  gap: 10px 12px;
  min-width: 0;
}

.netpa-fastpay__field {
  min-width: 0;
}

.netpa-fastpay__field span {
  display: block;
  margin-bottom: 3px;
  color: var(--nh-soft);
  font-size: 12px;
  line-height: 1.45;
}

.netpa-fastpay__field strong {
  display: block;
  color: var(--nh-navy);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.netpa-fastpay__field .is-penalty {
  color: #b44f46;
}

/* Notices inside NetPaCard */
.netpa-notices__filter-btn {
  color: var(--nh-blue) !important;
  font-size: 12px !important;
  font-weight: 700;
  background: transparent !important;
  border: none !important;
}

.netpa-notices__body {
  max-height: 280px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.netpa-notices__loading {
  display: flex;
  justify-content: center;
  padding: 18px 0;
}

.netpa-notices__empty {
  padding: 16px 14px;
  color: var(--nh-muted);
  font-size: 13px;
  text-align: center;
  border-radius: 20px;
  background: #edf5fb;
}

.netpa-notice {
  display: flex;
  gap: 10px;
  padding: 12px 2px 14px;
  border-bottom: 1px solid var(--nh-border);
}

.netpa-notice:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.netpa-notice__dot {
  flex: 0 0 8px;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 50%;
  background: var(--nh-cyan);
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.12);
}

.netpa-notice__copy {
  min-width: 0;
  flex: 1;
}

.netpa-notice__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.netpa-notice__top strong {
  color: var(--nh-navy);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.45;
}

.netpa-notice__top time {
  flex-shrink: 0;
  color: var(--nh-soft);
  font-size: 11px;
}

.netpa-notice__copy p {
  display: -webkit-box;
  margin: 0 0 8px;
  overflow: hidden;
  color: var(--nh-muted);
  font-size: 13px;
  line-height: 1.65;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.netpa-notice__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.netpa-notice__btn {
  padding: 5px 10px;
  border: 0;
  border-radius: 14px;
  background: #edf5fb;
  color: var(--nh-blue);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.netpa-notice__btn--read {
  background: #eaf8f5;
  color: #078c7e;
}

/* Quick access grid */
.netpa-quick__grid,
.netpa-quick__grid--side {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(132px, 1fr));
  gap: 10px;
}

.netpa-quick__action {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 96px;
  padding: 12px 8px;
  color: #536579;
  text-decoration: none;
  border: 1px solid var(--nh-border);
  border-radius: 28px;
  background: var(--nh-soft-bg);
  transition:
    color 180ms ease,
    border-color 180ms ease,
    background 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
}

.netpa-quick__action:hover {
  color: var(--nh-navy);
  text-decoration: none;
  border-color: rgba(83, 121, 189, 0.28);
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 42, 79, 0.07);
  transform: translateY(-2px);
}

.netpa-quick__icon {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  border-radius: 18px;
  color: var(--nh-blue);
  background: #edf5fb;
}

.netpa-quick__icon i {
  font-size: 16px;
}

.netpa-quick__action:nth-child(6n + 2) .netpa-quick__icon {
  color: #078c7e;
  background: #eaf8f5;
}

.netpa-quick__action:nth-child(6n + 3) .netpa-quick__icon {
  color: var(--nh-purple);
  background: #f5eff8;
}

.netpa-quick__action:nth-child(6n + 4) .netpa-quick__icon {
  color: #b97916;
  background: #fff7e8;
}

.netpa-quick__action:nth-child(6n + 5) .netpa-quick__icon {
  color: #b44f46;
  background: #fcefed;
}

.netpa-quick__action:nth-child(6n + 6) .netpa-quick__icon {
  color: #068997;
  background: #e9f9fb;
}

.netpa-quick__action > span:last-child {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
}

/* Modal (tabloo full view) */
#Modal-light:has(.netpa-tabloo-modal) .modal-dialog {
  margin: 1.25rem auto;
  max-width: 640px;
}

#Modal-light:has(.netpa-tabloo-modal) .modal-content {
  border: none;
  border-radius: 28px;
  box-shadow: 0 8px 32px rgba(42, 63, 84, 0.18);
  overflow: hidden;
  height: auto;
  max-height: calc(100vh - 2.5rem);
}

#Modal-light:has(.netpa-tabloo-modal) .modal-body {
  padding: 0;
  height: auto;
}

.netpa-tabloo-modal {
  padding: 1rem 1.15rem 1.25rem;
}

.netpa-tabloo-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
  padding-bottom: 0.55rem;
  border-bottom: 1px solid rgba(42, 63, 84, 0.1);
}

.netpa-tabloo-modal__date {
  font-size: 12px;
  color: #6c757d;
}

.netpa-tabloo-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: rgba(42, 63, 84, 0.08);
  color: #2a3f54;
  cursor: pointer;
  flex-shrink: 0;
}

.netpa-tabloo-modal__title {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #2a3f54;
  margin: 0 0 0.75rem;
  line-height: 1.5;
  text-align: right;
  width: 100%;
}

.netpa-tabloo-modal__body {
  font-size: 13px;
  line-height: 1.85;
  color: #495057;
  text-align: justify;
  max-height: min(45vh, calc(100vh - 11rem));
  overflow-y: auto;
}

@media (max-width: 1180px) {
  .netpa-home__dashboard--with-side {
    grid-template-columns: minmax(0, 1.35fr) minmax(300px, 0.9fr);
  }
}

@media (max-width: 991px) {
  .netpa-home__dashboard--with-side,
  .netpa-home__columns {
    grid-template-columns: 1fr;
    grid-template-areas: none;
  }

  .netpa-home__stack--full,
  .netpa-home__stack--main,
  .netpa-home__stack--side,
  .netpa-home__stack--charts {
    grid-area: auto;
    grid-column: 1;
  }

  .netpa-home__stack--charts {
    grid-template-columns: 1fr;
  }

  .netpa-fastpay__list {
    max-height: 240px;
  }

  .netpa-notices__body {
    max-height: 240px;
  }
}

@media (max-width: 767px) {
  .netpa-home {
    --netpa-home-gap: 12px;
  }

  .netpa-fastpay__hero {
    padding: 16px;
  }

  .netpa-fastpay__hero-amount {
    font-size: 20px;
  }

  .netpa-fastpay__hero-words {
    font-size: 11px;
  }

  .netpa-fastpay__hero-meta {
    gap: 8px 12px;
    font-size: 12px;
  }

  .netpa-fastpay__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .netpa-fastpay__item {
    align-items: start;
  }

  .netpa-home .card.Netpa-Shadow.bnp-rounded {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }

  .netpa-billpay-card .netpa-billpay-title-row {
    margin-left: auto !important;
    margin-right: auto !important;
    width: calc(100% - 30px);
    max-width: 100%;
  }

  .netpa-billpay-card .card-body {
    padding-bottom: calc(3rem - 16px) !important;
  }

  #Modal-light:has(.netpa-tabloo-modal) .modal-dialog {
    margin: 16px auto;
    width: calc(100% - 32px);
    max-width: calc(100% - 32px);
  }

  #Modal-light:has(.netpa-tabloo-modal) .modal-content {
    width: 100%;
    max-height: calc(100vh - 32px);
    border-radius: 16px;
  }

  .netpa-tabloo-modal {
    padding: 1rem 1.1rem 1.15rem;
  }

  .netpa-tabloo-modal__body {
    max-height: min(40vh, calc(100vh - 9.5rem));
  }
}

@media (max-width: 420px) {
  .netpa-fastpay__fields {
    grid-template-columns: 1fr;
  }

  .netpa-fastpay__hero-amount {
    font-size: 18px;
  }
}

tspan {
  font-family: "";
}

.animate__animated.animate__swing {
  --animate-duration: 1s;
}

.Uploader {
  width: 100%;
  border: 2px dashed #0c6ec9 !important;
  border-radius: 8px;
}
.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
@media (min-width: 1500px) {
  .col-xxl-7 {
    flex: 0 0 calc(100% / 12 * 7);
    max-width: calc(100% / 12 * 7);
  }
}
</style>
